import { useEffect, useState } from 'react';

type UpdateValueReturn = { isAnimated: boolean; animatedValue: number };

type UpdateValueProps = {
  shouldAnimate: boolean;
  value: number;
  animationSpeed: number;
  increment?: number;
  valueSuffix?: any;
};

export const useUpdateCurrentValue = ({
  shouldAnimate,
  value,
  animationSpeed,
  increment,
  valueSuffix
}: UpdateValueProps): UpdateValueReturn => {
  const [state, setState] = useState({
    isAnimated: false,
    animatedValue: 0
  });

  useEffect(() => {
    let interval;

    if (shouldAnimate) {
      interval = setInterval(() => {
        setState((prevProgress) => {
          const nextValue = Math.min(prevProgress.animatedValue + increment, value);
          const isFinishedAnimating = nextValue >= value;

          if (isFinishedAnimating) {
            clearInterval(interval);
            return {
              ...prevProgress,
              isAnimated: true,
              animatedValue: value
            };
          } else {
            return {
              ...prevProgress,
              animatedValue: nextValue
            };
          }
        });
      }, animationSpeed);
    }

    return () => clearInterval(interval);
  }, [animationSpeed, value, shouldAnimate, increment]);

  return {
    isAnimated: state.isAnimated,
    animatedValue: valueSuffix ? state.animatedValue + valueSuffix : state.animatedValue
  };
};
